import React from 'react';
import {Button, Dropdown, notification} from 'antd';
import {BankOutlined, CheckOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import {useSWRConfig} from 'swr';
import useSWRMutation from 'swr/mutation';
import {Base64} from 'js-base64';
import {account_organization_switch} from '../../api/api';
import {afterRequest, isOrganizationScopedKey, triggerAxios} from '../../api/config';
import {useAuth} from '../../config/AuthProvider';

const OrganizationSwitch = () => {
    const {t} = useTranslation();
    const {userData, updateUserData} = useAuth();
    const {mutate} = useSWRConfig();
    const {trigger, isMutating} = useSWRMutation(account_organization_switch, triggerAxios);

    // `organizations[].organization` is the organization id; `organizations[].id`
    // is the assignment row id — the switch endpoint expects the former.
    const organizations = userData?.organizations || [];
    const current = organizations.find(i => i.organization === userData?.organization_id);

    if (organizations.length < 2) return null;

    const switchTo = (organizationId) => {
        if (isMutating || organizationId === userData?.organization_id) return;
        afterRequest(trigger, {method: 'POST', data: {organization: organizationId}}, (res) => {
            const nextUserData = {
                ...userData,
                organization_id: res?.organization_id ?? organizationId,
                organizations: res?.organizations || organizations,
            };
            localStorage.setItem('authority', Base64.encode(JSON.stringify(nextUserData)));
            updateUserData(nextUserData);
            mutate(isOrganizationScopedKey);
            notification.success({
                message: t('organizationSwitched'),
                description: res?.organizations?.find(i => i.organization === res?.organization_id)?.name,
                pauseOnHover: true,
            });
        });
    };

    const items = organizations.map(i => ({
        key: i.organization,
        label: i.name || `${t('organization')} ${i.organization}`,
        icon: i.organization === userData?.organization_id ? <CheckOutlined/> : <BankOutlined/>,
        onClick: () => switchTo(i.organization),
    }));

    return (
        <Dropdown menu={{items}} placement="bottom" trigger={['click']}>
            <Button size={'large'} loading={isMutating} icon={<BankOutlined/>}>
                {current?.name || t('switchOrganization')}
            </Button>
        </Dropdown>
    );
};

export default OrganizationSwitch;
